import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import LocalizedMessage from '../../components/LocalizedMessage';
import classes from './Loader.module.scss';

const Loader = ({active, withText, withDescription, withBackground, description, isSmall, className}) => {
  return (
    <div
      className={cx(
        classes.Loader,
        {
          [classes.LoaderActive]: active,
          [classes.LoaderSmall]: isSmall,
          [classes.LoaderWithBackground]: withBackground && !isSmall
        },
        className
      )}
    >
      <div className={classes.LoaderContent}>
        <ul className={classes.LoaderAnimation}>
          {
            new Array(12).fill(null).map((value, index) => (
              <li
                key={index}
                className={classes.LoaderAnimationItem}
              />
            ))
          }
        </ul>
        {
          withText && !isSmall ?
            <p className={classes.LoaderText}>
              <LocalizedMessage
                id='base.loading'
              />
            </p>
            : null
        }
        {
          withDescription && !isSmall ?
            <p className={classes.LoaderDescription}>
              {
                description ||
                <LocalizedMessage
                  id='base.loadingDescription'
                />
              }
            </p>
            : null
        }
      </div>
    </div>
  );
};

Loader.defaultProps = {
  active: true,
  withText: true,
  withDescription: false,
  withBackground: true,
  isSmall: false,
  className: null
};

Loader.propTypes = {
  active: PropTypes.bool,
  withText: PropTypes.bool,
  withDescription: PropTypes.bool,
  withBackground: PropTypes.bool,
  description: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  isSmall: PropTypes.bool,
  className: PropTypes.string
};

export default Loader;
